import React from "react";
import { AcceleratorGallery } from "../../components/accelerator/AcceleratorShared";
import { REVIEWGEN_ACCELERATORS } from "../../utils/reviewgen/constants";

export default function ReviewGenPage() {
  return (
    <AcceleratorGallery
      eyebrow="Development"
      title="ReviewGen"
      subtitle="AI-powered code review solutions for your development ecosystem"
      data={REVIEWGEN_ACCELERATORS}
      searchPlaceholder="Search ReviewGen..."
      emptyNoun="reviewgen"
    />
  );
}
